import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { scopeLoader } from '@libraries/transloco-root';
import { YodleeFastlinkComponent } from './yodlee-fastlink/yodlee-fastlink.component';
import { YodleeConfig } from './yodlee.config';

@NgModule({
  imports: [CommonModule, MatCardModule, MatProgressSpinnerModule, TranslocoModule],
  declarations: [YodleeFastlinkComponent],
  exports: [YodleeFastlinkComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      multi: true,
      useValue: {
        scope: 'yodlee',
        loader: scopeLoader((lang: string, root: string) => import(`./${root}/${lang}.json`)),
      },
    },
  ],
})
export class YodleeModule {
  constructor(config: YodleeConfig) {
    if (!config) {
      throw new Error('Provide config for YodleeModule using the forRoot method');
    }
  }

  static forRoot(config: YodleeConfig): ModuleWithProviders<YodleeModule> {
    return {
      ngModule: YodleeModule,
      providers: [
        {
          provide: YodleeConfig,
          useValue: config,
        },
      ],
    };
  }
}
